import React from "react"
import styled from "react-emotion"
import { withRouter } from "react-router"
import { browserHistory } from "react-router"

import { LeftBar } from "../ui/Frame"
import AddBlockPane from "./AddBlockPane"
import PageSettingsPane from "./PageSettingsPane"
import ButtonPane from "../ui/ButtonPane"
import Icon from "ui/components/Icon"
import Button from "ui/legacy/Button"
import LayersPane from "./LayersPane"

const LeftSidebar = props => {
    return (
        <LeftBar>
            <TinyLogo
                onClick={browserHistory.goBack}
                src="/static/media/stacker-logo.32813f5d.png"
            />

            <ButtonPane hotkey="meta+i" icon={<Icon icon="plus" margin="none" />}>
                {({ close, hide }) => <AddBlockPane hide={hide} close={close} />}
            </ButtonPane>
            <ButtonPane icon={<Icon icon="th-list" margin="non" />}>
                {({ close, hide }) => <LayersPane hide={hide} close={close} />}
            </ButtonPane>
            <ButtonPane icon={<Icon icon="cog" margin="none" />}>
                {({ close, hide }) => (
                    <PageSettingsPane
                        page={props.page}
                        savePage={props.savePage}
                        hide={hide}
                        close={close}
                    />
                )}
            </ButtonPane>
        </LeftBar>
    )
}

export default withRouter(LeftSidebar)

const TinyLogo = styled("img")`
    height: 24px;
    padding: 2px 6px;
    margin-top: 2px;
}
`



// WEBPACK FOOTER //
// ./src/features/editor/sidebars/LeftSidebar.js